<template>
  <div class="chemicalInfoBox">
    <div class="head">
      <div class="">
        <el-button type="primary" size="small" @click="$router.push('AddChemicalInfo')">新建</el-button>
      </div>
    </div>
    <div class="bodyBox">
      <div class="bodyTitle">
        <Input search enter-button placeholder="请输入化学品名称" style="width: 260px" @on-search="search" v-model="searchContent" />
        <el-button type="danger" size="small" v-show="multipleSelection.length > 0" @click="deleteBatch">批量删除</el-button>
      </div>
      <!-- 表格 -->
      <div>
        <el-table
          ref="multipleTable"
          :data="tableData" :row-key="getRowKey" :row-style="{height: '70px'}"
          tooltip-effect="dark" :header-cell-style="{background: 'rgb(250,250,250)',height: '70px'}"
          style="width: 100%" @row-click="handleRowClick"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection" :reserve-selection="true"
            width="55">
          </el-table-column>
          <el-table-column prop="name" label="中文名" width="150px">
            <template slot-scope="{ row }">
              <el-link :underline="false" type="priamry" @click.stop="openDrawer(row.id)">{{ row.name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="alias" label="别名" width="150px" />
          <el-table-column prop="category" label="化学品类型" width="150px" />
          <el-table-column prop="casNumber" label="CAS号" width="150px">
            <template slot-scope="{ row }">
              <el-link :underline="false" type="primary" @click.stop="openDrawer(row.id, 'second')">{{ row.casNumber }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="作用" width="150px" />
          <el-table-column label="年产品生产能力" width="150px">
            <template slot-scope="scope">
              {{ scope.row.proAbility }} {{ scope.row.unit }}
            </template>
          </el-table-column>
          <el-table-column label="年产品最大储量" width="150px">
            <template slot-scope="scope">
              {{ scope.row.proReserves }} {{ scope.row.unit }}
            </template>
          </el-table-column>
          <el-table-column label="最大储存量" width="150px">
            <template slot-scope="scope">
              {{ scope.row.maxReserves }} {{ scope.row.unit }}
            </template>
          </el-table-column>
          <el-table-column label="实际储量" width="150px">
            <template slot-scope="scope">
              {{ scope.row.reserves }} {{ scope.row.unit }}
            </template>
          </el-table-column>
          <el-table-column label="储存方式/地点" prop="storageMethodPlace" width="150px" />
          <el-table-column label="是否重点监管危险化学品" width="150px">
            <template slot-scope="scope">
              {{ scope.row.isEmphasisSupervise == 0 ? '否' : '是' }}
            </template>
          </el-table-column>
          <el-table-column label="安全措施" prop="safeMeasures" width="150px" show-overflow-tooltip />
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <span class="tableBtn" style="color:#40a9ff" @click.stop="edit(scope.row)">编辑</span>
              <span style="color:#e8e8e8;margin: 0 5px">|</span>
              <span class="tableBtn" style="color:#40a9ff" @click.stop="managerBtn(scope.row)">管理</span>
              <span style="color:#e8e8e8;margin: 0 5px">|</span>
              <span class="tableBtn" style="color:#ff0000" @click.stop="remove(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="paginationBox">
          <el-pagination
            background @current-change="pageChange"
            layout="prev, pager, next"
            :total="total" :page-size="limit" :current-page="curPage">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 点击管理按钮的弹窗 -->
    <Modal
      v-model="modal1"
      title="储量管理"
      @on-ok="ok" @on-cancel="cancel">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="类型">
          <el-radio-group v-model="form.type" size="small">
            <el-radio-button :label="1">入库</el-radio-button>
            <el-radio-button :label="2">出库</el-radio-button>
            <el-radio-button :label="3">报废</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="form.num" size="small"></el-input>
        </el-form-item>
      </el-form>
    </Modal>

    <!-- 抽屉 -->
    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      direction="rtl"
      size="65%"
      :show-close="false"
      :before-close="handleClose">
      <div slot="title" class="drawerTitle">
        <p>{{ drawerObj.name }}
          <i class="el-icon-circle-close" @click="handleClose"></i>
        </p>
        <div class="tWord">
          <div><p>CAS号</p><span>{{ drawerObj.casNumber }}</span></div>
          <div><p>别名</p><span>{{ drawerObj.alias }}</span></div>
          <div><p>化学品类型</p><span>{{ drawerObj.category }}</span></div>
        </div>
      </div>
      <div class="drawerBody">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="记录" name="first"></el-tab-pane>
          <el-tab-pane label="MSDS" name="second"></el-tab-pane>
        </el-tabs>
        <!-- 记录的内容 -->
        <div class="bodyInner" v-if="activeName === 'first'">
          <el-card class="box-card" v-for="item in drawerObj.record" :key="item.id">
            <div class="text item">
              <p>{{ drawerObj.name }}</p>
              <p>{{ item.inOut === 1 ? '入库' : item.inOut === 2 ? '出库' : '报废' }}
                {{ item.mun + '' + drawerObj.unit }}
              </p>
              <p>负责人 {{ item.operator }}</p>
              <p>{{ item.gmtModified }}</p>
            </div>
          </el-card>
        </div>
        <!-- MSDS -->
        <div class="bodyInner" v-if="activeName === 'second'">
          <iframe v-if="(fileFormat === 'pdf' || fileFormat === 'PDF')
           && drawerObj.msds !== '' && drawerObj.msds !== 'null'"
            :src="host + drawerObj.msds.filePath"
            type="application/x-google-chrome-pdf"
            width="100%"
            height="100%" />
          <img style="width: 100%" 
            v-if="drawerObj.msds !== '' && drawerObj.msds !== 'null'
            && fileFormat !== 'pdf' && fileFormat !== 'PDF'"
            :src="host + drawerObj.msds.filePath" alt=""
          />
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getChemicalList, deleteChemical, hemicalIn, chemicalOut,
 deleteBatch1, getChemicalDetail } from '@/api/processManager'
export default {
  name: 'ProcessChemicalInfo',
  data() {
    return {
      // 多选表格的数据
      tableData: [],
      // 已选中的数据
      multipleSelection: [],
      // 管理按钮的弹窗
      modal1: false,
      form: {
        type: 0,
        num: 0,
        id: ''
      },
      searchContent: "",
      // 分页的数据
      limit: 10,
      curPage: 1,
      total: 0,
      row: {}, // 储存某一行的数据，用于判断出入库数量
      drawer: false, // 抽屉的状态
      activeName: 'first',
      drawerObj: {
        msds: { filePath: '' }
      }, // 抽屉的数据
      fileFormat: ''
    }
  },
  methods: {
    getRowKey( row ){ return row.id },
    // 选中的数据改变时触发的事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击行选中
    handleRowClick(row) {
      this.$refs['multipleTable'].toggleRowSelection(row)
    },
    // 表格的管理按钮
    managerBtn(val) {
      this.modal1 = true
      this.form.id = val.id
      this.row = {...val}
    },
    // 管理按钮弹窗的事件
    ok () {
      if(this.form.type === 1){
        if((this.row.reserves*1 + this.form.num*1) > this.row.maxReserves){
          this.$message.error('超出最大储量')
          return
        }
        hemicalIn({id: this.form.id,num: this.form.num}).then(res => {
          this.getList()
        })
      }else{
        if(this.row.reserves*1 < this.form.num*1) {
          this.$message.error('超出储量')
          return
        }
        chemicalOut({ ...this.form }).then(res => {
          this.getList()
        })
      }
    },
    // 当前页改变的事件
    pageChange(val) {
      this.curPage = val
      this.getList()
    },
    // 获取表格数据
    getList(val) {
      if(val || val===0) {
        getChemicalList({limit: this.limit,curPage: this.curPage, name: val}).then(res => {
          this.tableData = res.body.data
          this.total = res.body.cum
        })
      }else{
        getChemicalList({limit: this.limit,curPage: this.curPage}).then(res => {
          this.tableData = res.body.data
          this.total = res.body.cum
        })
      }
    },
    // 编辑
    edit(row) {
      this.$router.push({
        path: 'AddChemicalInfo',
        query: {
          message: {...row}
        }
      })
    },
    // 删除
    remove(val) {
      this.$confirm(`删除 ${val.name}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteChemical(val.id).then(res => {
          if(this.tableData.length <= 1 && this.curPage > 1) {
            this.curPage -= 1
          }
          this.getList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        return
      });
    },
    // 批量删除
    deleteBatch() {
      // console.log(this.multipleSelection)
      let arr = []
      for(let i in this.multipleSelection){
        arr.push(this.multipleSelection[i].id)
      }
      let obj = {ids: arr}
      deleteBatch1({ids: arr}).then(res => {
        this.curPage = 1
        this.getList()
      })
    },
    // 搜索
    search() {
      // console.log(this.searchContent)
      this.getList(this.searchContent)
    },
    // 弹窗关闭
    cancel() {
      this.form.num = 0
    },
    // 打开抽屉
    openDrawer(id, status) {
      if(status) {
        this.activeName = 'second'
      }
      getChemicalDetail(id).then(res => {
        this.$nextTick(() => {
          this.drawerObj = res.body.data
          if(this.drawerObj.msds !== 'null' && this.drawerObj.msds !== undefined && this.drawerObj.msds !== 'undefined'
           && this.drawerObj.msds !== '' && this.drawerObj.msds !== null){
            this.drawerObj.msds = JSON.parse(this.drawerObj.msds)
            this.fileFormat = this.drawerObj.msds.filePath.split('.')[1]
          }
        })
      })
      this.drawer = true
    },
    // 关闭抽屉
    handleClose() {
      this.drawer = false
      this.activeName = 'first'
    },
    // 抽屉里面的tab切换
    handleClick(val) {
      this.activeName = val.name
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
.head {
 display: flex;
 justify-content: space-between
}

.bodyBox {
  width: 100%;
  /* height: 300px; */
  padding: 15px;
  background: white
}
.bodyTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.tableBtn {
  cursor: pointer;
}
.paginationBox {
  text-align: right;
  margin-top: 15px;
}
.paginationBox /deep/ .el-pager li {
  background-color: white
}
.drawerTitle {
  box-shadow: 0px 5px 5px -5px black;
  height: 120px;
  padding-left: 15px;
}
.drawerTitle > p {
  color: #000000;
  font-size: 18px;
  line-height: 55px;
}
.drawerTitle > p > i {
  font-size: 30px;
  float: right;
  margin: 15px 10px 0 0;
}
.drawerTitle > p > i:hover {
  color: #409EFF
}
.chemicalInfoBox /deep/ .el-drawer__header {
  padding: 0;
  margin-bottom: 0
}

.chemicalInfoBox /deep/ .el-card__body {
  padding: 8px 20px;
  color: #777777
}
.box-card {
  margin-bottom: 5px
}

/* 解决tab切换会有蓝色边框的问题 */ 
.chemicalInfoBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
box-shadow: none;
border-top-left-radius: 20px;
border-top-right-radius: 20px;
}

/*  */

.tWord {
  display: flex
}
.tWord div > p {
  font-size: 15px;
  line-height: 25px
}
.tWord div > span {
  color: #000000
}
.tWord div {
  width: 220px
}
.drawerBody {
  width: 100%;
  height: calc(100vh - 120px);
  background: rgb(247,247,247);
  overflow: hidden;
  padding: 10px 20px 20px;
}
.bodyInner {
  background: white;
  height: calc(100% - 60px);
  width: 100%;
  border: 1px solid #eaeaea;
  overflow: scroll;
}
</style>
